import { Route, Routes } from "react-router";

import { ErrorPage } from "./Error/Error";
import { LoginPage } from "./0_Auth/Login/Login";
import { RecuperarContrasenaPage } from "./0_Auth/RecuperarContrasena/RecuperarContrasena";

import { GestionArticulosPage } from "./1_GestionArticulos/GestionArticulos";

import { EmpaquetadoPage } from "./2_Pedidos/Empaquetado/Empaquetado";
import { EmpaquetadoPedidosPage } from "./2_Pedidos/EmpaquetadoPedidos/EmpaquetadoPedidos";
import { AsignarCiclosPage } from "./2_Pedidos/AsignarCiclos/AsignarCiclos";
import { LanzarCiclosPage } from "./2_Pedidos/LanzarCiclos/LanzarCiclos";

import { GestionFasesPage } from "./3_Produccion/GestionFases/GestionFases";
import { GestionOFsPage } from "./3_Produccion/GestionOFs/GestionOFs";
import { ListadoOPEPage } from "./3_Produccion/ListadoOPE/ListadoOPE";

import { GestionPuestosPage } from "./4_Config/GestionPuestos/GestionPuestos";
import { GestionUbicacionesPage } from "./4_Config/GestionUbicaciones/GestionUbicaciones";
import { GestionUsuariosPage } from "./4_Config/GestionUsuarios/GestionUsuarios";
import { SincroAlmacenPage } from "./4_Config/SincroAlmacen/SincroAlmacen";
import { CambiarContrasenaPage } from "./0_Auth/CambiarContrasena/CambiarContrasena";
import { TemplateMenu } from "../templates/TemplateMenu";
import { TemplateLogin } from "../templates/TemplateLogin";
import { GestionFamiliasOcultasPage } from "./4_Config/GestionFamiliasOcultas/GestionFamiliasOcultas";

export function MyRouter() {
	return (
		<Routes>
			<Route element={<TemplateLogin />} >
				<Route index path="/" element={<LoginPage />} />
				<Route path="/login" element={<LoginPage />} />
				<Route path="/recuperarcontrasena" element={<RecuperarContrasenaPage />} />
				<Route path="/cambiarcontrasena" element={<CambiarContrasenaPage />} />

				<Route path="/error" element={<ErrorPage />} />
			</Route>

			<Route element={<TemplateMenu />} >
				<Route path="/order" element={<GestionArticulosPage />} />

				<Route path="/cycles" element={<LanzarCiclosPage />} />
				<Route path="/factory" element={<AsignarCiclosPage />} />
				<Route path="/empaquetado" element={<EmpaquetadoPage />} />
				<Route path="/empaquetadop" element={<EmpaquetadoPedidosPage />} />

				<Route path="/ordermanager" element={<GestionOFsPage />} />
				<Route path="/opes" element={<ListadoOPEPage />} />
				<Route path="/gestionfases" element={<GestionFasesPage />} />

				<Route path="/workstation" element={<GestionPuestosPage />} />
				<Route path="/syncro" element={<SincroAlmacenPage />} />
				<Route path="/users" element={<GestionUsuariosPage />} />
				<Route path="/locationmanager" element={<GestionUbicacionesPage />} />
				<Route path="/familiasOcultas" element={<GestionFamiliasOcultasPage />} />
			</Route>
		</Routes>
	);
}